import { render, staticRenderFns } from "./WidgetQualificationTime.vue?vue&type=template&id=64175e12&scoped=true&"
import script from "./WidgetQualificationTime.vue?vue&type=script&lang=js&"
export * from "./WidgetQualificationTime.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64175e12",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VDataTable})
